export default {
	methods: 
    {		
		openModals(modal)
		{
		  this.updateGlobal({state: 'indexData', data: false});
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: modal.title});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: modal.modal});
		},	
	},
}